<button
  uiButton
  [text]="true"
  [outlined]="false"
  type="button"
  class="workflow-catalog-sort-button"
  [attr.aria-label]="'Sort ' + label + ' on this page'"
  [disabled]="!sortable"
  (click)="sort($event)"
>
  {{ label }}
  <i
    aria-hidden="true"
    class="pi"
    [class.pi-sort-alt]="!sortDirection"
    [class.pi-sort-amount-up-alt]="sortDirection === 'asc'"
    [class.pi-sort-amount-down]="sortDirection === 'desc'"
  ></i>
</button>
